import moment from 'moment'

export default {
  install (Vue) {
    Object.defineProperty(Vue.prototype, '$moment', { value: moment })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/moment.js